import type { Dates } from '@types';

export function getRepeatFrequencyDays(repeatFrequency: Dates['daysAndTimesRepeatFrequency']) {
  switch (repeatFrequency) {
    case 'disabled':
      return 0; // No repetition, can be interpreted as disabled or no repeat interval
    case 'repeat-every-week':
      return 7; // Repeat every week
    case 'repeat-every-2-weeks':
      return 14; // Repeat every 2 weeks
    case 'repeat-every-3-weeks':
      return 21; // Repeat every 3 weeks
    case 'repeat-every-4-weeks':
      return 28; // Repeat every 4 weeks
    default:
      return null; // Handle invalid inputs gracefully
  }
}
